import React from 'react'
import { Route, Switch, useRouteMatch } from 'react-router-dom'
import SponsorListing from 'views/admin/sponsors/SponsorListing'
import SponsorForm from 'views/admin/sponsors/SponsorForm'

const Sponsors = () => {
  const { path } = useRouteMatch()
  return (
    <Switch>
      <Route exact path={path}>
        <SponsorListing />
      </Route>
      <Route path={`${path}/new`}>
        <SponsorForm displayContext="page" />
      </Route>
      <Route path={`${path}/edit/:sponsorId`}>
        <SponsorForm displayContext="page" />
      </Route>
    </Switch>
  )
}

export default Sponsors
